import { useCallback, useEffect, useState } from 'react';

const TOAST_MS = 2500;

/**
 * The toast inside the viewer ("Link copied", "Link turned off"; designs a2, a4). It draws in the
 * viewer, above the stage, so no app layer hides it.
 */
export function useViewerToast(): { toast: string | null; showToast: (text: string) => void } {
  const [toast, setToast] = useState<string | null>(null);
  useEffect(() => {
    if (toast === null) {
      return undefined;
    }
    const timer = setTimeout(() => setToast(null), TOAST_MS);
    return () => clearTimeout(timer);
  }, [toast]);
  const showToast = useCallback((text: string) => setToast(text), []);
  return { toast, showToast };
}
